import type { ItemFeature } from "./ItemFeature";
import type { MonetaryAmountDto } from "./MonetaryAmountDto";

export enum CreateBidRequestStatusBid {
    "NEW" = "NEW",
    "CANCELED" = "CANCELED"
}
export enum CreateBidRequestFieldsMode {
    "ANALOGUE" = "ANALOGUE",
    "ORIGINAL" = "ORIGINAL"
}
export type CreateBidRequest = {
    /**
     * @type integer int64
    */
    tenderItemId: number;
    /**
     * @type array
    */
    features: ItemFeature[];
    price: MonetaryAmountDto;
    /**
     * @type string
    */
    statusBid: CreateBidRequestStatusBid;
    /**
     * @type string | undefined
    */
    fieldsMode?: CreateBidRequestFieldsMode;
};
